module.exports = __webpack_public_path__ + "img/banner-4.89d0b31c.png";